exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#routerView .swiper-slide {\n  overflow: auto !important;\n}\n@media screen and (min-width: 415px) {\n.key-box {\n    font-size: 0.8rem;\n}\n.font-18 {\n    font-size: 0.8rem;\n}\n}\n.level-box {\n  width: 3.3rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1cc4265a","scoped":false,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Posture_sympipad.vue
// module id = ZtK3
// module chunks = 1